<template>
    <div class="bidder-child-page">
         <div class="page-header">
            <div class="page-header-content">
                <h2 class="page-title">{{projectTitle}}</h2>
                <h2 class="page-title">缴纳技术服务费</h2>
            </div>
            <div class="header-action">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>
        <!-- 页面内容区域 -->
        <div class="content-wrap">
            <!-- 说明必看区域 -->
            <div class="instruction-section">
                <h3 class="section-title">说明(必看):</h3>
                <div class="warning-text">
                    <span class="red-text">谨慎操作,缴费后无法退还</span>
                </div>
                <div class="instruction-content">

                    <div> <span>在<span class="text-accent">上传投标文件</span>之前,需要先支付本次投标的技术服务费</span></div>
                    <div> <span>在<span class="text-accent">中标公告</span>发布完成之后,可以前往左侧导航栏"投标管理-->>
                            我的订单"中申请发票。支持类型:纸质。</span></div>
                </div>
            </div>
            <!-- 支付详情区域 -->
            <div class="payment-section">
                <h3 class="section-title">支付详情</h3>
                <div class="payment-info">
                    <div class="info-item">
                        <span class="label">当前费用依据项目标段的金额采用阶梯计价</span>
                    </div>
                    <div class="payment-row">
                        <div class="info-item">
                            <span class="label">支付订单编号:</span>
                            <span class="value">{{ formatField(paymentInfo.orderNumber) }}</span>
                        </div>
                        <div class="info-item">
                            <span class="label">订单时间:</span>
                            <span class="value">{{ formatField(paymentInfo.buyBidTime) }}</span>
                        </div>
                    </div>
                    <div class="payment-row">
                        <div class="info-item">
                            <span class="label">订单状态:</span>
                            <span class="value" :class="getStatusClass(paymentInfo.status)">{{
                                formatStatus(paymentInfo.status) }}</span>
                        </div>
                    </div>
                    <div class="info-item">
                        <span class="label">支付金额(元):</span>
                        <span class="value amount">{{ formatField(paymentInfo.orderPrice) }}</span>
                    </div>
                </div>
            </div>

            <!-- 支付按钮区域 -->
            <div class="payment-button-section">
                <el-button type="primary" size="medium" @click="handlePayment" class="payment-btn"
                    v-if="paymentInfo.status == 0">
                    支付订单
                </el-button>
            </div>
        </div>
        <!-- 支付二维码弹窗 -->
        <el-dialog title="扫码支付" :visible.sync="qrCodeDialogVisible" width="400px" center :close-on-click-modal="false"
            :append-to-body="true">
            <div class="qr-code-container">
                <div ref="qrCodeRef" class="qr-code-box"></div>
                <p class="qr-code-tip">请使用微信或支付宝扫描二维码完成支付</p>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="payClose">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getOrCreateBySectionCode, createPlatformServiceOrder } from '@/api/modules/tenderNotice'
import { createPlatformServiceOrderData, getPlatformServiceOrderData } from '@/api/modules/pay'
import { getBidderFlowTitle } from '@/utils/bid/projectInfo'
import QRCode from 'qrcodejs2'

export default {
    name: 'TechnologyFee',
    data() {
        return {
            projectTitle: '',
            sectionCode: this.$route.query.sectionCode || '',   // 获取项目编号
            projectInfo: {
                bidSectionName: '',
                submissionDeadline: this.$route.query.submissionDeadline || ''
            },
            paymentInfo: {
                orderNumber: '',
                status: null,
                orderPrice: null,
                buyBidTime: '',
                payType: null
            },
            // 二维码弹窗
            qrCodeDialogVisible: false,
            qrCodeInstance: null
        }
    },
    mounted() {
        this.getCreatePlatformServiceOrderData()
        this.getProjectInfo()

    },
    methods: {
        // 获取项目信息
        async getProjectInfo() {
            this.projectTitle = await getBidderFlowTitle(this.sectionCode);
        },

        // 获取购标数据
        getCreatePlatformServiceOrderData() {
            createPlatformServiceOrder({
                sectionCode: this.$route.query.sectionCode
            }).then(res => {
                if (res && res.data) {
                    const data = res.data
                    // 更新支付信息
                    this.paymentInfo.orderNumber = data.orderNumber || ''
                    this.paymentInfo.status = data.status
                    this.paymentInfo.orderPrice = data.orderPrice
                    this.paymentInfo.buyBidTime = data.buyBidTime || ''
                    this.paymentInfo.payType = data.payType
                }
            }).catch(error => {
                this.$message.error('获取订单信息失败')
            })
        },
        // 格式化字段，如果为空显示 "-"
        formatField(value) {
            if (value === null || value === undefined || value === '') {
                return '-'
            }
            return value
        },
        // 格式化订单状态
        formatStatus(status) {
            if (status === null || status === undefined) {
                return '-'
            }
            const statusMap = {
                0: '待支付',
                1: '已支付',
                2: '退款',
                3: '已上传支付凭证待审核'
            }
            return statusMap[status] || '-'
        },
        // 获取状态样式类
        getStatusClass(status) {
            if (status === 1) {
                return 'status-paid'
            }
            return ''
        },
        // 格式化支付方式
        formatPayType(payType) {
            if (payType === null || payType === undefined) {
                return '-'
            }
            const payTypeMap = {
                1: '线下支付',
                2: '线上支付'
            }
            return payTypeMap[payType] || '-'
        },
        handleBack() {
            this.$router.go(-1)
        },
        // 处理支付
        handlePayment() {
            if (!this.paymentInfo.orderNumber) {
                this.$message.warning('订单号不存在')
                return
            }
            createPlatformServiceOrderData({
                orderNumber: this.paymentInfo.orderNumber
            }).then(res => {
                if (res.code === 200 && res.data && res.data.payinfo) {
                    // 显示二维码弹窗
                    this.showQrCode(res.data.payinfo)
                } else {
                    this.$message.error(res.msg || '支付请求失败')
                }
            }).catch(error => {
                this.$message.error('支付请求失败')
                console.error('支付接口错误:', error)
            })
        },
        // 显示支付二维码
        showQrCode(payinfo) {
            this.qrCodeDialogVisible = true
            this.$nextTick(() => {
                // 清除旧的二维码
                if (this.$refs.qrCodeRef) {
                    this.$refs.qrCodeRef.innerHTML = ''
                }
                // 生成新的二维码
                this.qrCodeInstance = new QRCode(this.$refs.qrCodeRef, {
                    text: payinfo,
                    width: 200,
                    height: 200,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                })
            })
        },
        // 关闭支付二维码弹窗
        payClose() {
            this.qrCodeDialogVisible = false
            getPlatformServiceOrderData({
                orderNumber: this.paymentInfo.orderNumber
            }).then(res => {
                if (res.code === 200 && res.data) {
                    this.getCreatePlatformServiceOrderData()
                }
            }).catch(error => {
                this.$message.error('获取订单信息失败')
            })
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-child-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.header-action {
    text-align: end;
    flex-shrink: 0;
}

.page-title {
    color: @gray-700;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
}

.content-wrap {
    padding: 20px;
    border-radius: 8px;
    box-shadow: @shadow-sm;
    background: #fff;
    text-align: start;
}

.section-title {
    color: @gray-700;
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 16px 0;

    &.project-title {
        padding-bottom: 12px;
        border-bottom: 1px solid @gray-300;
    }

    &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 16px;
        margin-right: 10px;
        border-radius: 2px;
        background: @gray-500;
        vertical-align: -2px;
    }

}

.text-accent {
    color: @error-color;
    font-weight: 600;
}

.instruction-section,
.account-section,
.project-section,
.payment-section {
    margin-bottom: 24px;
    padding: 20px;
    background: @gray-50;
    border: 1px solid @gray-200;
    border-radius: 8px;
}

.instruction-section {
    .warning-text {
        margin: 0 0 12px;
    }

    .red-text {
        color: @error-color;
        font-weight: 600;
    }

    .instruction-content {
        display: flex;
        flex-direction: column;
        gap: 10px;

        span {
            line-height: 1.6;
            font-weight: 500;
            color: @gray-600;
        }
    }
}

.account-section {
    .account-info {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
        gap: 12px 24px;

        .info-item {
            display: flex;
            align-items: flex-start;
            padding: 14px 16px;
            background: #fff;
            border: 1px solid @gray-200;
            border-radius: 6px;

            .label {
                min-width: 80px;
                color: @gray-500;
                font-weight: 500;
            }

            .value {
                color: @gray-700;
                flex: 1;
                word-break: break-all;
            }
        }
    }
}

.project-section {
    .project-info {
        .project-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 20px;
            padding: 4px 0;
        }

        .project-name {
            color: @gray-700;
            font-size: 24px;
            font-weight: 700;
            flex: 1;
            min-width: 200px;
            line-height: 1.5;
        }

        .deadline {
            display: flex;
            align-items: center;
            flex-shrink: 0;
            padding: 12px 16px;
            background: #fff;
            border: 1px solid @gray-200;
            border-radius: 6px;

            .label {
                color: @gray-500;
                margin-right: 10px;
            }

            .red-text {
                color: @error-color;
                font-weight: 600;
            }
        }
    }
}

.payment-section {
    .payment-info {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .payment-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 20px;
        }

        .info-item {
            display: flex;
            align-items: center;
            flex: 1;
            min-width: 200px;
            padding: 14px 16px;
            background: #fff;
            border: 1px solid @gray-200;
            border-radius: 6px;

            .label {
                min-width: 120px;
                color: @gray-500;
                font-weight: 500;
            }

            .value {
                color: @gray-700;
                flex: 1;

                &.status-paid {
                    color: @success-color;
                    font-weight: 600;
                }

                &.amount {
                    color: @gray-700;
                    font-weight: 700;
                    font-size: 16px;
                }
            }
        }
    }
}

.payment-button-section {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid @gray-200;
    text-align: center;

    .payment-btn {
        padding: 12px 60px;
        font-size: 16px;
        font-weight: 600;
        border-radius: 4px;
    }
}

// 二维码弹窗样式
.dialog-footer {
    text-align: center;
    border-top: 1px solid @gray-200;
    padding-top: 16px;
}

.qr-code-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;

    .qr-code-box {
        padding: 14px;
        background: #fff;
        border: 1px solid @gray-200;
        border-radius: 8px;
        box-shadow: @shadow-sm;
    }

    .qr-code-tip {
        margin-top: 15px;
        color: @gray-500;
        font-size: 14px;
    }
}

/deep/ .el-dialog {
    border-radius: 8px;
}

/deep/ .el-dialog__header {
    background: @gray-50;
    border-bottom: 1px solid @gray-200;
}

/deep/ .el-dialog__title {
    color: @gray-700;
    font-weight: 600;
}

@media (max-width: 768px) {
    .bidder-child-page {
        padding: 16px;
    }

    .page-header {
        flex-direction: column;
        align-items: stretch;
    }

    .header-action {
        text-align: left;
    }

    .content-wrap,
    .instruction-section,
    .account-section,
    .project-section,
    .payment-section {
        padding: 16px;
    }

    .project-section {
        .project-info {
            .project-name {
                font-size: 20px;
            }

            .deadline {
                width: 100%;
                justify-content: space-between;
            }
        }
    }

    .payment-section {
        .payment-info {
            .info-item {
                flex-direction: column;
                align-items: flex-start;
                gap: 8px;

                .label {
                    min-width: auto;
                }
            }
        }
    }
}
</style>